/* wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbvbI6%7Bdisplay%3Ainline-block%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdRAKS%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzlyLl%7Bcolor%3Avar(--logo-color)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1rdFvh4YQS%7Bfill%3Avar(--logo-fill)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._26BoRw7dHp%7Bline-height%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._20VacPYbGa%7B-webkit-user-select%3Anone%3B-moz-user-select%3Anone%3Buser-select%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ANEUSzUZr%7Bwhite-space%3Anormal%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2kxbLJN91d%20%3Esvg%7Bheight%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0fvd5AOLYo%20%3Esvg%7Bfill%3Ainherit%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24fbFs98eZ%20stop%7Bstop-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0Vey7F%7Bheight%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VSPN1%7Bheight%3A20px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VoWWg%7Bheight%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VUofl%7Bheight%3A2pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VUF4f%7Bheight%3A40px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VpJKa%7Bheight%3A3pc%7D");
import { type WrapperProps } from './constants';
const CSS_VAR_COLOR = '--logo-color';
const CSS_VAR_FILL = '--logo-fill';
const styles = {
  root: "_3iDTPbvbI6 _1mT5xdRAKS _1UtDYzlyLl _1rdFvh4YQS _26BoRw7dHp _20VacPYbGa _1ANEUSzUZr _2kxbLJN91d _0fvd5AOLYo",
  stop: "_24fbFs98eZ",
  xxsmall: "_0jFU0Vey7F",
  xsmall: "_0jFU0VSPN1",
  small: "_0jFU0VoWWg",
  medium: "_0jFU0VUofl",
  large: "_0jFU0VUF4f",
  xlarge: "_0jFU0VpJKa"
};

/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */
const Wrapper = ({
  label,
  svg,
  size,
  appearance,
  iconColor,
  textColor,
  testId: userDefinedTestId,
  ...rest
}: WrapperProps): JSX.Element => {
  // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
  const shouldApplyStopColor = appearance === undefined;
  const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
  return <span data-testid={testId} style={({
    [CSS_VAR_COLOR]: iconColor,
    [CSS_VAR_FILL]: textColor
  } as React.CSSProperties)} aria-label={label ? label : undefined} role={label ? 'img' : undefined} dangerouslySetInnerHTML={{
    __html: svg
  }}
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  {...rest} className={ax([styles.root, shouldApplyStopColor && styles.stop, size && styles[size]])} />;
};
export default Wrapper;